import { errorCodes, getUserFriendlyErrorMessage } from '../../../utils/errormessages'
import { maxTextLength, text } from '../constants'
import type { NewServiceVisitType } from '../types'

type TextErrorsMessages = {
  nameError: string
  descriptionError: string
}

export const checkTextErrors = (serviceType: Pick<NewServiceVisitType, 'Name' | 'Description'>): TextErrorsMessages => {
  const { Name, Description } = serviceType
  const name = Name ?? ''
  const description = Description ?? ''

  const textErrorsMessages: TextErrorsMessages = {
    nameError: '',
    descriptionError: '',
  }

  if (name.trim() === '') {
    textErrorsMessages.nameError = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.VISIT_NAME)
  }

  if (name.trim().length > maxTextLength.SERVICE_NAME) {
    textErrorsMessages.nameError = getUserFriendlyErrorMessage(errorCodes.MAX_CHARACTER_LIMIT, null, text.VISIT_NAME)
  }

  if (description.trim() === '') {
    textErrorsMessages.descriptionError = getUserFriendlyErrorMessage(errorCodes.FIELD_REQUIRED, null, text.DESCRIPTION)
  }

  if (description.trim().length > maxTextLength.DESCRIPTION) {
    textErrorsMessages.descriptionError = getUserFriendlyErrorMessage(
      errorCodes.MAX_CHARACTER_LIMIT,
      null,
      text.DESCRIPTION,
    )
  }

  return textErrorsMessages
}
